import { Pill } from "@src/appV2/redesign/system/ui-components";

import { getConsequenceDisplay } from "./getConsequenceDisplay";

export type Consequence = number | "Restriction" | "On Restriction" | "Instant restriction";

interface ConsequencePillProps {
  consequence: Consequence;
}

export function ConsequencePill({ consequence }: ConsequencePillProps) {
  const { label, color, isRestricted, isNoConsequence, isNegativeConsequence } =
    getConsequenceDisplay(consequence);

  return (
    <Pill
      label={label}
      size="small"
      color={color}
      backgroundColor={(theme) => {
        if (isRestricted || isNoConsequence) {
          return theme.palette.grey[200];
        }

        return isNegativeConsequence
          ? theme.palette.intent?.error.background
          : theme.palette.intent?.success.background;
      }}
    />
  );
}
